module.exports = {"130982001":"新华路街道","130982002":"西环路街道","130982003":"永丰路街道","130982004":"中华路","130982100":"出岸镇","130982101":"石门桥镇","130982102":"吕公堡镇","130982103":"长丰镇","130982104":"鄚州镇","130982105":"苟各庄镇","130982106":"梁召镇","130982107":"辛中驿镇","130982108":"麻家坞镇","130982203":"议论堡乡","130982204":"青塔乡","130982205":"北辛庄乡","130982206":"七间房乡","130982207":"北汉乡","130982208":"于村乡","130982400":"华北石油管理局","130982500":"开发区管理委员会","130982501":"河北任丘雁翎工业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130982.json
// module id = 203
// module chunks = 0